var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Twitter Config Type: "),_c('v-select',{attrs:{"items":['timeline','highlight'],"label":"Type"},model:{value:(_vm.config.twitter.type),callback:function ($$v) {_vm.$set(_vm.config.twitter, "type", $$v)},expression:"config.twitter.type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }